<template>
    <el-card shadow="hover">
        <label slot="header">JFile文件组件</label>
        <el-divider content-position="left">type = list</el-divider>
        <j-file use-fully src="https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg" name="测试图片.jpeg" />
        <el-divider content-position="left">type = card</el-divider>
        <j-file use-fully type="card" src="https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg" name="测试图片.jpeg" />
        <el-divider content-position="left">type = icon</el-divider>
        <j-file use-fully type="icon" src="https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg" name="测试图片.jpeg" />
        <el-divider content-position="left">使用插槽插入自定义行为</el-divider>
        <j-file style="display: block" use-fully type="icon" src="https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg" name="测试图片.jpeg">
            <i class="el-icon-star-off" @click="slotClick" />
        </j-file>
        <j-file style="display: block" use-fully type="card" src="https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg" name="测试图片.jpeg">
            <i class="el-icon-star-off" @click="slotClick" />
        </j-file>
        <j-file use-fully type="list" src="https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg" name="测试图片.jpeg">
            <i class="el-icon-star-off" @click="slotClick" />
        </j-file>
        <el-divider content-position="left">使用文件服务地址</el-divider>
        <el-link type="primary" @click="refClick">上传一个文件测试</el-link>
        <j-upload v-show="false" ref="JuploadRef"
                  @upload-complete="uploadComplete"
                  need-fully/>
        <j-file type="list" :src="src" />
        <j-file type="icon" :src="src" style="display: block" />
        <j-file type="card" :src="src" style="display: block" />
    </el-card>
</template>

<script>
    import JFile from "./JFile";
    import JUpload from "../JUpload/JUpload";
    export default {
        name: "JFileDemo",
        components: {
            JFile,
            JUpload
        },
        data() {
            return {
                src: ''
            }
        },
        methods: {
            slotClick () {
               this.$message.info('点击了插槽的自定义图标')
            },
            refClick () {
                this.$refs.JuploadRef && this.$refs.JuploadRef.UploadTrigger()
            },
            uploadComplete (src) {
                console.log('上传链接',src)
                this.src = src
            }
        }
    }
</script>
